import { Timestamp } from 'firebase/firestore';

import { TNullableString } from '../base';
import { IEventAtRead, IEventAtWrite } from '../event';

export enum EProfileType {
  TRUST = 'trust',
  PERSONAL = 'personal',
  BUSINESS = 'business'
}

export enum EProfileRole {
  NONE = 'none',
  OWNER = 'owner',
  READER = 'reader',
  EDITOR = 'editor',
  WRITER = 'writer'
}

export type TProfileRole = Record<string, Omit<EProfileRole, EProfileRole.NONE>>;

export enum EProfileStatus {
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  NOT_INVITED = 'not-invited',
  INVITE_PENDING = 'invite-pending'
}

export interface IProfileWrite {
  name: string;
  type: EProfileType;
  ownerUserId: string;
  countryCode: string;
  isVaultSetup: boolean;
  email: TNullableString;
  status: EProfileStatus;
  created: IEventAtWrite;
  updated: IEventAtWrite;
  access: Record<string, boolean>;
  photoURL: TNullableString;
  promoCode: TNullableString;
  estateReadinessScore: number;
  estateReadinessGapCount: number;
  billingUserId: TNullableString;
  paymentMethodId: TNullableString;
  suspendedReason: TNullableString;
  billingOrganisationId: TNullableString;
  billingOrganisationSlug?: TNullableString;
  estateReadinessGap?: Record<string, unknown> | null;
}
export interface IProfileRead extends IProfileWrite {
  id: string;
  created: IEventAtRead;
  updated: IEventAtRead;
}

export interface IProfileSummaryBaseDocument {
  name: string;
  type: string;
  categoryId: string;
  categoryName: string;
  categoryIconUrl: string;
  // uploaded document details
  fileName: string | null;
  url: string | null;
  documentId: string | null;
  uploadedAt: Timestamp | null;
}

export interface IKYCDocs {
  proofOfResidence: IProfileSummaryBaseDocument;
  proofOfIdentity: IProfileSummaryBaseDocument;
}

export interface ILastWillAndTestament extends IProfileSummaryBaseDocument {
  lastUpdatedAt: Timestamp;
}
export interface IExpiringDocument {
  name: string;
  url: string;
  entityId?: string;
  categoryId: string;
  expiresAt: Timestamp;
  categoryName: string;
  categoryIconUrl: string;
}
export interface IProfileSummaryRead {
  id: string;
  created: IEventAtRead;
  updated: IEventAtRead;
  kyc: IKYCDocs;
  will: ILastWillAndTestament;
  expiringDocuments: Record<string, IExpiringDocument>;
}
